/**
 * One idempotency id per user click for catalog control actions. Generate it when
 * the action starts and reuse it on a network retry, so the server answers
 * `applied:false` instead of acting twice; never reuse it for a different action.
 */
export function newCorrelationId(): string {
  return crypto.randomUUID();
}
